var _path, _path2, _path3, _path4;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPrinter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.75,6a1,1,0,0,0,1-1V2.25A.25.25,0,0,1,7,2h8.586L17.75,4.164V5a1,1,0,0,0,2,0V3.75a1,1,0,0,0-.293-.707L17,.588A2.01,2.01,0,0,0,15.586,0H6.75a2,2,0,0,0-2,2V5A1,1,0,0,0,5.75,6Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.5,7H2.5A2.5,2.5,0,0,0,0,9.5V14a2.5,2.5,0,0,0,2.5,2.5H5v6.25A1.25,1.25,0,0,0,6.25,24h12a1.251,1.251,0,0,0,1.25-1.25V16.5h2A2.5,2.5,0,0,0,24,14V9.5A2.5,2.5,0,0,0,21.5,7Zm-18,4.5a1,1,0,1,1,1-1A1,1,0,0,1,3.5,11.5Zm14,10a.5.5,0,0,1-.5.5H7.5a.5.5,0,0,1-.5-.5V12.458a.5.5,0,0,1,.5-.5H17a.5.5,0,0,1,.5.5Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15,14.75H9.5a.75.75,0,0,0,0,1.5H15a.75.75,0,0,0,0-1.5Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.25,18.25H9.5a.75.75,0,0,0,0,1.5h3.75a.75.75,0,0,0,0-1.5Z"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrinter);
export default __webpack_public_path__ + "static/media/printer.9109dd00960f741a125a05c30b2ee4e5.svg";
export { ForwardRef as ReactComponent };